module.exports = __webpack_public_path__ + "static/img/Fitlers-active.b09f9631.svg";